import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.div`
  padding: 16px 16px 32px;
  height: 150px;

  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.mediumRadius};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 12px;

  & > h2 {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    letter-spacing: -0.02em;
    color: ${theme.colors.lightBrown};
  }

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    letter-spacing: -0.02em;
    color: ${theme.colors.mediumGray};
  }
`

export const Content = styled.div`
  & > h3 {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.semiBold};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    letter-spacing: -0.02em;
    color: ${theme.colors.lightBrown};
  }
  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    letter-spacing: -0.02em;
    color: ${theme.colors.lightBrown};
  }
`
